<template>
  <!-- <v-window v-model="step" data-qa="standingorderdetails-window-vq3lla">
  <v-window-item :value="1" data-qa="standingorderdetails-window-item-xewi5q"> -->
  <v-flex class="standingOrders" data-qa="standingorderdetails-flex-l755ye">
    <v-layout wrap class="ml-2 standingOrders--gradientBGposition" data-qa="standingorderdetails-layout-bpoaa">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient, height: '180px' }"
       data-qa="standingorderdetails-flex-2dui9s">
        <v-container class="standingOrders--title-padding" data-qa="standingorderdetails-container-0e21o">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="standingorderdetails-flex-609fsg">
            <v-row no-gutters data-qa="standingorderdetails-row-jhkjjb">
              <v-layout row wrap class="pb-2 pl-12" data-qa="standingorderdetails-layout-5ir45k">
                    <div class="pt-3" data-qa="standingorderdetails-div-xmj7a5">
                    <v-avatar :tile="false" size="35" color="white" data-qa="standingorderdetails-avatar-bsjyja">
                      <v-icon :color="primaryColor" data-qa="standingorderdetails-icon-mltyni">mdi-file-multiple-outline</v-icon>
                    </v-avatar>
                    </div>
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4 pl-2" data-qa="standingorderdetails-flex-wekp6">
                  <v-row no-gutters data-qa="standingorderdetails-row-kuo5b">
                    <font class="text-h5 font-weight-light white--text">
                      {{ $t("recurringAndFuturePayments.recurring")}}  &
                      {{ $t("recurringAndFuturePayments.futurePayments")}}</font
                    >
                  </v-row>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
        <!-- </v-layout> -->
      </v-flex>
    </v-layout>
    <v-flex
      xs12
      sm12
      md10
      lg10
      xl10
      class="standingOrders--content-padding standingOrders--overlayCardFlex" data-qa="standingorderdetails-flex-c1l5q">
    <v-layout row wrap class="standingOrders--content-padding" data-qa="standingorderdetails-layout-llcon8">
      <v-flex
          sm12
          xs12
          md12
          lg12
          xl12
          class="hidden-lg-and-up bottom--pb10"
         data-qa="standingorderdetails-flex-js08xh">
          <v-btn
            v-if="!futurePayment"
            color="white"
            class="text-none px-4 py-2"
            outlined
            @click="navigateToList(true)"
             data-qa="standingorderdetails-btn-7c3lqro">{{$t('recurringAndFuturePayments.gotoRecurringPaymentsBtn')}}</v-btn
          >
          <v-btn
            v-else
            color="white"
            class="text-none px-4 py-2"
            outlined
            @click="navigateToList(true)"
             data-qa="standingorderdetails-btn-g3yojt">{{$t('recurringAndFuturePayments.gotoFuturePaymentsBtn')}}</v-btn
          >
        </v-flex>
        <v-flex xs10 sm10 md10 lg10 xl10 class="pt-0" data-qa="standingorderdetails-flex-ao6ie6">
          <!-- 1st Tab -->

          <v-card data-qa="standingorderdetails-card-elt4wb">

          </v-card>
          <v-layout data-qa="standingorderdetails-layout-3quse">
          <!-- 2nd Tab -->
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="standingorderdetails-flex-i9ood">
          <v-card v-if="config.type === 'same'" width="700" data-qa="standingorderdetails-card-xhua5f">
            <v-container data-qa="standingorderdetails-container-gl5yxp">
              <v-layout row justify-space-between data-qa="standingorderdetails-layout-gwww3i">
                <!-- <v-row pl-4 no-gutters class="mr-16" data-qa="standingorderdetails-row-lslumr"> -->
                  <!-- <v-col cols="12" sm="6" md="4" data-qa="standingorderdetails-col-q1nv6s"> -->
                  <v-flex xs12 sm12 md12 lg12 xl12 data-qa="standingorderdetails-flex-d0tgwu">
                   <v-col cols="6" class="px-6 pt-3 pb-0" data-qa="standingorderdetails-col-pgs4p">
                    <font class="text-h6 font-weight-bold">{{ $t("recurringAndFuturePayments.details") }}</font>
                   </v-col>
                  </v-flex>
                  <v-card-text class="text--primary pt-0" data-qa="standingorderdetails-card-text-ek8j2m">
                <v-row no-gutters data-qa="standingorderdetails-row-4jrt30c">
                  <!--Repeat row with info-->
                  <v-col cols="6" class="px-2 pt-3" data-qa="standingorderdetails-col-q8o454">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-h5r6z">
                      {{ $t("recurringAndFuturePayments.fromAccount") }}
                    </div>
                    <div class="pa-1 pt-0" data-qa="standingorderdetails-div-0agng">
                      {{ fromAccountType }}
                    </div>
                  </v-col>
                  <v-col cols="6" class="px-6 pt-3" data-qa="standingorderdetails-col-mc5ft7">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-1mqsvc">
                      {{ $t("recurringAndFuturePayments.toAccount") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-rjnl7h">{{toAccountType}}</div>
                  </v-col>

                  <v-col cols="6" class="px-2 pt-3" data-qa="standingorderdetails-col-5d2hxc">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-ihlv3">
                      {{ $t("recurringAndFuturePayments.amount") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-nu5mb">
                      {{$formatter.currency.format(config.transferToAccountDetails[0].amount.value, config.transferToAccountDetails[0].amount.currency)}}
                    </div>
                  </v-col>
                  <v-col v-if="!futurePayment" cols="6" class="px-6 pt-3" data-qa="standingorderdetails-col-52l0z9">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-pjra9o">
                      {{ $t("recurringAndFuturePayments.creationDate") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-d9a6bj">
                      {{ $formatter.formatDate(config.creationDateTime.substr(0, 10)) }}
                    </div>
                  </v-col>

                  <v-col
                    v-if="!futurePayment"
                    cols="6"
                    class="px-2 pt-3"
                   data-qa="standingorderdetails-col-9l5gua">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-qa1oyh">
                      {{ $t("recurringAndFuturePayments.paymentStartDate") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-sdbslv">
                      {{ $formatter.formatDate(config.startDate.substr(0, 10)) }}
                    </div>
                  </v-col>
                  <!-- <v-col
                    cols="6"
                    class="px-6 pt-3"
                    v-if="futurePayment"
                   data-qa="standingorderdetails-col-llcnmq">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-l8pkpc">
                      {{ $t("recurringAndFuturePayments.paymentDate") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-sxyd1i">
                      {{ $formatter.formatDate(config.startDate.substr(0, 10)) }}
                    </div>
                  </v-col> -->
                  <v-col v-if="futurePayment" cols="6" class="px-6 pt-3" data-qa="standingorderdetails-col-9h4p0m">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-ejor9f">
                      {{ $t("recurringAndFuturePayments.paymentDate") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-aualrk">{{ $formatter.formatDate(config.nextPaymentDate.substr(0, 10)) }}</div>
                  </v-col>
                  <v-col
                    v-if="futurePayment"
                    cols="6"
                    class="px-2 pt-3"
                   data-qa="standingorderdetails-col-c6k16l">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-lq0q15">
                      {{ $t("recurringAndFuturePayments.remarks") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-aeejie">
                      {{ config.description }}
                    </div>
                  </v-col>
                  <v-col v-if="!futurePayment && config.endDate" cols="6" class="px-6 pt-3" data-qa="standingorderdetails-col-umgqk">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-0svvwk">
                      {{ $t("recurringAndFuturePayments.paymentEndDate") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-26jzi">{{ $formatter.formatDate(config.endDate.substr(0, 10)) }}</div>
                  </v-col>
                  <v-col v-if="!futurePayment && config.numberOfPayments" cols="6" class="px-6 pt-3" data-qa="standingorderdetails-col-f6fv8">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-ukxk7g">
                      {{ $t("recurringAndFuturePayments.numberOfPayments") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-gbtec">{{ config.numberOfPayments }}</div>
                  </v-col>
                  <v-col v-if="!futurePayment" cols="6" class="px-2 pt-3" data-qa="standingorderdetails-col-vihwgb">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-xzpxrh">
                      {{ $t("recurringAndFuturePayments.nextPaymentDate") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-9rgr2k">{{ $formatter.formatDate(config.nextPaymentDate.substr(0, 10)) }}</div>
                  </v-col>
                  <v-col v-if="!futurePayment" cols="6" class="px-6 pt-3" data-qa="standingorderdetails-col-lifmfe">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-e83ii">
                      {{ $t("recurringAndFuturePayments.frequency") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-hp8ss">{{ capitalizeFirstLetter(config.frequency) }}</div>
                  </v-col>
                  <v-col v-if="!futurePayment" cols="6" class="px-2 pt-3" data-qa="standingorderdetails-col-r3s4sv">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-s37yo">
                      {{ $t("recurringAndFuturePayments.description") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-fl2beo">{{ config.description }}</div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions data-qa="standingorderdetails-card-actions-tzvzq9">
                <v-btn
                  v-if="enableSO.delete"
                  class="text-capitalize ma-2 py-2 px-4"
                  :color="primaryColor"
                  outlined
                  @click ="deleteStandingOrder()"
                   data-qa="standingorderdetails-btn-pbpyq8">{{ $t("recurringAndFuturePayments.deleteBtn") }}</v-btn
                >
                <v-btn
                  v-if="enableSO.amend"
                  class="text-capitalize ma-2 white--text py-2 px-4"
                  :color="primaryColor"
                  @click ="navigateToAmend()"
                   data-qa="standingorderdetails-btn-pim0x">{{ $t("recurringAndFuturePayments.amendBtn") }}</v-btn
                >
                </v-card-actions>
              </v-layout>
            </v-container>
          </v-card>
          <v-card v-else width="700" data-qa="standingorderdetails-card-b2oy1">
            <v-container data-qa="standingorderdetails-container-vg5yjs">
              <v-layout row justify-space-between data-qa="standingorderdetails-layout-ki26q9">
                <!-- <v-row pl-4 no-gutters class="mr-16" data-qa="standingorderdetails-row-0zpu5e"> -->
                  <!-- <v-col cols="12" sm="6" md="4" data-qa="standingorderdetails-col-siq1gc"> -->
                  <v-flex xs12 sm12 md12 lg12 xl12 data-qa="standingorderdetails-flex-gpkmaf">
                   <v-col cols="6" class="px-6 pt-3 pb-0" data-qa="standingorderdetails-col-nurzos">
                    <font class="text-h6 font-weight-bold">{{ $t("recurringAndFuturePayments.details") }}</font>
                   </v-col>
                  </v-flex>
                  <v-card-text class="text--primary pt-0" data-qa="standingorderdetails-card-text-9ww2rx">
                <v-row no-gutters data-qa="standingorderdetails-row-fy66w6">
                  <!--Repeat row with info-->
                  <v-col cols="6" class="px-2 pt-3" data-qa="standingorderdetails-col-40dp2e">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-l43fqi">
                      {{ $t("recurringAndFuturePayments.fromAccount") }}
                    </div>
                    <div class="pa-1 pt-0" data-qa="standingorderdetails-div-8bkfe">
                      {{ fromAccountType }}
                    </div>
                  </v-col>
                  <v-col cols="6" class="px-6 pt-3" data-qa="standingorderdetails-col-m3dfl">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-2al61b">
                      {{ config.paymentInstruction.paymentSystem === 'STEP2' ? $t("recurringAndFuturePayments.toAccountSEPA") : $t("recurringAndFuturePayments.toAccount") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-bqpwj8">{{config.paymentInstruction.cdtrAccount}} | {{config.paymentInstruction.cdtrBankIdentifier}}</div>
                  </v-col>

                  <v-col cols="6" class="px-2 pt-3" data-qa="standingorderdetails-col-owzy86">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-iefcxj">
                      {{ $t("recurringAndFuturePayments.amount") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-sfm3b7">
                      {{$formatter.currency.format(config.paymentInstruction.instructionAmount.amount, config.paymentInstruction.instructionAmount.currency)}}
                    </div>
                  </v-col>
                  <v-col
                    v-if="!futurePayment"
                    cols="6"
                    class="px-6 pt-3"
                   data-qa="standingorderdetails-col-jrxjt">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-lsvzf">
                      {{ $t("recurringAndFuturePayments.paymentStartDate") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-y2o46d">
                      {{ $formatter.formatDate(config.standingOrderSetup.fromDate) }}
                    </div>
                  </v-col>
                  <v-col v-if="!futurePayment && config.standingOrderSetup" cols="6" class="px-2 pt-3" data-qa="standingorderdetails-col-4wpjc">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-hsw6s4j">
                      {{ $t("recurringAndFuturePayments.numberOfPayments") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-l3p6jg">{{ config.standingOrderSetup.numberOfPayments }}</div>
                  </v-col>
                  <v-col v-if="!futurePayment" cols="6" class="px-6 pt-3" data-qa="standingorderdetails-col-ksoxl">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-67v36k">
                      {{ $t("recurringAndFuturePayments.nextPaymentDate") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-r06kb">{{ $formatter.formatDate(config.standingOrderSetup.nextExecutionDate.substr(0, 10)) }}</div>
                  </v-col>
                  <v-col v-if="futurePayment" cols="6" class="px-6 pt-3" data-qa="standingorderdetails-col-rvdy66">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-yiz7fq">
                      {{ $t("recurringAndFuturePayments.paymentDate") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-lmp0en">{{ $formatter.formatDate(config.standingOrderSetup.fromDate) }}</div>
                  </v-col>
                  <v-col v-if="!futurePayment" cols="6" class="px-2 pt-3" data-qa="standingorderdetails-col-c5q5ir">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-yvzg5">
                      {{ $t("recurringAndFuturePayments.paymentEndDate") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-cifz7l">{{ $formatter.formatDate(config.standingOrderSetup.toDate) }}</div>
                  </v-col>
                  <v-col v-if="!futurePayment" cols="6" class="px-6 pt-3" data-qa="standingorderdetails-col-6trrf">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-naobqf">
                      {{ $t("recurringAndFuturePayments.frequency") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-574e8r">{{ config.standingOrderSetup.frequency ? capitalizeFirstLetter(config.standingOrderSetup.frequency) : '' }}</div>
                  </v-col>
                  <v-col cols="6" class="px-2 pt-3" data-qa="standingorderdetails-col-pcdqwp">
                    <div class="pa-1 overline font-weight-bold" data-qa="standingorderdetails-div-0evi9b">
                      {{ $t("recurringAndFuturePayments.description") }}
                    </div>
                    <div class="pa-1" data-qa="standingorderdetails-div-stezds">{{ config.description }}</div>
                  </v-col>
                </v-row>
              </v-card-text>
              <!-- <v-layout row data-qa="standingorderdetails-layout-6xeg2q"> -->
                <v-flex v-if="enableAmendandCancel" xs11 sm5 md5 lg3 xl5 class="pl-4 py-2" data-qa="standingorderdetails-flex-em8cnf">
                <v-layout data-qa="standingorderdetails-layout-7g06ye">
                <v-btn
                  v-if="enableSO.delete"
                  class="text-capitalize ma-2 py-2 px-4"
                  :color="primaryColor"
                  outlined
                  @click ="deleteStandingOrder()"
                   data-qa="standingorderdetails-btn-evkeqbq">{{ $t("recurringAndFuturePayments.deleteBtn") }}</v-btn
                >
                <v-btn
                  v-if="enableSO.amend"
                  class="text-capitalize ma-2 white--text py-2 px-4"
                  :color="primaryColor"
                  @click ="navigateToAmend()"
                   data-qa="standingorderdetails-btn-a0wdz9">{{ $t("recurringAndFuturePayments.amendBtn") }}</v-btn
                >
                </v-layout>
              </v-flex>
              <!-- </v-layout> -->
                <!-- </v-row> -->
              </v-layout>
            </v-container>
          </v-card>
          </v-flex>
          <v-flex
          sm12
          xs12
          md12
          lg12
          xl12
          class="hidden-md-and-down standingOrders--newBill"
          style="align-items:end;margin-bottom:40px;margin-left:20px;"
         data-qa="standingorderdetails-flex-vjhu5c">
          <v-btn
            v-if="!futurePayment"
            color="white"
            class="text-none px-4 py-2"
            outlined
            @click="navigateToList(true)"
             data-qa="standingorderdetails-btn-xe9u2">{{$t('recurringAndFuturePayments.gotoRecurringPaymentsBtn')}}</v-btn
          >
          <v-btn
            v-else
            color="white"
            class="text-none px-4 py-2"
            outlined
            @click="navigateToList(true)"
             data-qa="standingorderdetails-btn-b4czu">{{$t('recurringAndFuturePayments.gotoFuturePaymentsBtn')}}</v-btn
          >
        </v-flex>
    </v-layout>
    <Modal
      v-if="removeStandingOrder"
      :config="getDeleteDialogConfig"
      @btn1Action="setOtpComp()"
      @btn2Action="onCancel()">
    </Modal>
    <Modal
      v-if="showConfirmationModal"
      :config="getSuccessDialogConfig"
      @btn1Action="navigateToList(true)">
    </Modal>
        </v-flex>
      </v-layout>
          <!-- OTP Section -->
    <Modal
      v-if="!enablePaymentPage && !this.futurePayment && enableOTPForRecurringPayments && showOTPScreen"
      :config="modalConfig.otp"
      @save="deleteStandingOrderById"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="standingorderdetails-span-gbe9z">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <Modal
      v-if="!enablePaymentPage && this.futurePayment && enableOTPForFuturePayments && showOTPScreen"
      :config="modalConfig.otp"
      @save="deleteStandingOrderById"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="standingorderdetails-span-yxxe65">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <!-- For OTP -->
    </v-flex>
  </v-flex>
  <!-- </v-window-item>
  </v-window> -->
</template>

<script>
import '@/styles/pages/standingOrders.scss'
import event from '@/util/event'
import moment from 'moment'
import store from '@/core/store'
import OtpInput from '@/components/common/OtpInput.vue'
import CommonService from '@/service/commonService.js'
export default {
  name: 'StandingOrderDetails',
  components: {
    OtpInput,
    Modal: () => import('@/components/common/Modal.vue')
  },
  props: {
    sOConfig: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      enablePaymentPage: true,
      currentDate: new Date(new Date().setFullYear(new Date().getFullYear())).toISOString().substr(0, 10),
      enableAmendandCancel: true,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations
          .otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        deleteWarning: {
          enabled: false,
          persistent: true,
          title: this.$t('recurringAndFuturePayments.recurringAndFutureDelete'),
          btn1Label: this.$t('recurringAndFuturePayments.delete'),
          btn2Label: this.$t("recurringAndFuturePayments.cancel"),
          width: 500
        },
        cancelSuccess: {
          enabled: false,
          persistent: true,
          title: this.$t('recurringAndFuturePayments.cancelSuccessTitle'),
          width: 500
        }
      },
      enableOTPForRecurringPayments: this.$appSettings.defaultConfigurations
        .enableOTPForRecurringPayments,
      enableOTPForFuturePayments: this.$appSettings.defaultConfigurations
        .enableOTPForFuturePayments,
      showOTPScreen: false,
      fromAccountType: '',
      toAccountType: '',
      removeStandingOrder: false,
      showConfirmationModal: false,
      futurePayment: false,
      isSEPAaccount: false,
      fromAccTypeCode: '',
      config: this.sOConfig,
      permissions: [],
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      enableSO: {
        amend: false,
        delete: false
      }
    }
  },
  created () {
    event.$on('reviewDetails', (args) => {
      this.config = args
      if (this.config && this.config.standingOrderSetup && this.config.standingOrderSetup.nextExecutionDate <= this.currentDate) {
        this.enableAmendandCancel = false
      } else {
        this.enableAmendandCancel = true
      }
      this.getConfig(this.config)
    })
    event.$on('disableFuturePaymentDetails', () => {
      this.futurePayment = false
    })
    event.$on('IS_OTP_VALID', (valid) => {
      if (valid) {
        this.modalConfig.otp.enabled = true
        this.amendOrder = true
        if (!this.enablePaymentPage && !this.futurePayment && this.enableOTPForRecurringPayments && this.showOTPScreen) {
          this.deleteStandingOrderById()
        }
        if (!this.enablePaymentPage && this.futurePayment && this.enableOTPForFuturePayments && this.showOTPScreen) {
          this.deleteStandingOrderById()
        }
      } else {
        this.amendOrder = false
      }
    })
    event.$on('OTP_RESENT', (val) => {
      this.modalConfig.otp.enableSave = true
    })
    if (this.config && this.config.standingOrderSetup && this.config.standingOrderSetup.nextExecutionDate <= this.currentDate) {
      this.enableAmendandCancel = false
    } else {
      this.enableAmendandCancel = true
    }
    this.getConfig(this.config)
    this.permissions = store.getters['profileStore/profileData']?.permissions
    this.enableSO.amend = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('EDIT_STANDING_ORDER') : true
    this.enableSO.delete = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('DELETE_STANDING_ORDER') : true
  },
  computed: {
    getDeleteDialogConfig () {
      return {
        ...this.modalConfig.deleteWarning,
        enabled: this.removeStandingOrder,
        btn2Color: this.errorColor,
        btn1Color: this.errorColor,
        body: !this.futurePayment ? this.$t('recurringAndFuturePayments.deleteRecurringPayment') : this.$t('recurringAndFuturePayments.deleteFuturePayment')
      }
    },
    getSuccessDialogConfig () {
      return {
        ...this.modalConfig.cancelSuccess,
        btn1Label: this.futurePayment ? this.$t('recurringAndFuturePayments.goToFuturePaymentsList') : this.$t('recurringAndFuturePayments.goToRecurringPaymentsList'),
        enabled: this.showConfirmationModal,
        body: !this.futurePayment ? this.$t('recurringAndFuturePayments.cancelRecurringPaymentSuccessMessage') : this.$t('recurringAndFuturePayments.cancelFuturePaymentSuccessMessage')
      }
    }
  },
  methods: {
    async getConfig (config) {
      if (config.startDate && config.endDate && config.frequency === 'DAILY') {
        const startDate = moment(config.startDate, 'YYYY-MM-DD')
        const endDate = moment(config.endDate, 'YYYY-MM-DD')
        const diff = endDate.diff(startDate, 'days')
        if (diff === 1) {
          this.futurePayment = true
        } else {
          this.futurePayment = false
        }
      }
      if (config.startDate && config.nextPaymentDate && config.frequency === 'DAILY') {
        const startDate = moment(config.startDate, 'YYYY-MM-DD')
        const nextPaymentDate = moment(config.nextPaymentDate, 'YYYY-MM-DD')
        // const diff = endDate.diff(startDate, 'days')
        if ((nextPaymentDate >= startDate) && config.numberOfPayments === 1 && config.frequency === 'DAILY') {
          this.futurePayment = true
        } else {
          this.futurePayment = false
        }
      }
      if (config.type === 'other') {
        // this.futurePayment = false
        if (config.standingOrderSetup && config.standingOrderSetup.fromDate && config.standingOrderSetup.toDate) {
          if (config.standingOrderSetup.numberOfPayments === 1 && config.standingOrderSetup.frequency === 'DAILY') {
            this.futurePayment = true
          } else {
            this.futurePayment = false
          }
        }
        if (config && config.paymentInstruction && config.paymentInstruction.cdtrAccount) {
          // this.getAccountDetails(config.paymentInstruction.cdtrAccount, 'toAccount')
        }
        if (config && config.paymentInstruction && config.paymentInstruction.debtorAccount) {
          await this.getAccountDetails(config.paymentInstruction.debtorAccount, 'fromAccount')
        }
      }
      if (config && config.transferFromAccountDetails && config.transferFromAccountDetails.length) {
        await this.getAccountDetails(config.transferFromAccountDetails[0].accountId, 'fromAccount')
      }
      if (config && config.transferToAccountDetails && config.transferToAccountDetails.length) {
        await this.getAccountDetails(config.transferToAccountDetails[0].accountId, 'toAccount')
      }
    },
    onOtpModalClose () {
      this.enablePaymentPage = false
      this.showOTPScreen = false
      this.modalConfig.otp.enabled = false
    },
    setOtpComp () {
      if (!this.futurePayment && this.enableOTPForRecurringPayments) {
        // create acc WITH otp Authentication
        this.enablePaymentPage = false
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
        this.modalConfig.otp.enableSave = true
      } else if (this.futurePayment && this.enableOTPForFuturePayments) {
        this.enablePaymentPage = false
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
        this.modalConfig.otp.enableSave = true
      } else {
        this.deleteStandingOrderById()
      }
    },
    async getAccountDetails (accountId, account) {
      let localeKey
      const response = await CommonService.getAccountDetails(accountId)
      if (response.accountType) {
        switch (response.accountType) {
          case 'SVGS':
            localeKey = 'savingsLabel'
            break
          case 'CACC':
            localeKey = 'currentLabel'
            break
          case 'TXSV':
            localeKey = 'cashIsaLabel'
            break
          case 'TXEA':
            localeKey = 'txeaCashIsaLabel'
            break
          case 'NACC':
            localeKey = 'noticeLabel'
            break
          case 'TXNA':
            localeKey = 'taxNoticeLabel'
            break
          case 'TXFR':
            localeKey = 'txfrCashIsaLabel'
            break
          default:
            break
        }

        if (account === 'fromAccount' && !['NACC', 'TXNA'].includes(response.accountType)) {
          this.fromAccTypeCode = response.accountType
          this.fromAccountType = this.$t(`termDepositActions.listAC.${localeKey}`) + ' ' + '-' + ' ' + accountId
        } else if (account === 'toAccount') {
          this.toAccountType = this.$t(`termDepositActions.listAC.${localeKey}`) + ' ' + '-' + ' ' + accountId
        }
      } else {
        if (account === 'toAccount') this.toAccountType = accountId
      }
      this.isSEPAaccount = response && response.iban
    },

    deleteStandingOrder () {
      this.removeStandingOrder = true
    },

    onCancel () {
      this.removeStandingOrder = false
    },
    handleOTPError (res) {
      if (res?.internalType === 'OTP-ERROR') {
        event.$emit('otp_validation_failed', res)
        return
      }

      this.onOtpModalClose()
    },
    async deleteStandingOrderById () {
      // this.onOtpModalClose()
      this.removeStandingOrder = false
      if (this.config && this.config.standingOrderId && this.config.type === 'same') {
        const response = await CommonService.cancelStandingOrder(this.config.standingOrderId)
        if (response.cancelDateTime) {
          this.showConfirmationModal = true
        }
        this.handleOTPError(response)
      }

      if (this.config && this.config.standingOrderId && this.config.type === 'other') {
        const request = {
          standingOrderStatus: 'ACTIVE',
          customerId: this.config.customerId,
          debtorAccountType: 'PROPRIETARY',
          debtorAccount: this.config.paymentInstruction.debtorAccount
        }
        const response = await CommonService.cancelInterBankStandingOrder(request, this.config.standingOrderId)
        if (response.standingOrderStatus === 'CANCELLED') {
          this.showConfirmationModal = true
        }
        this.handleOTPError(response)
      }
    },

    navigateToList (reloadList) {
      this.showConfirmationModal = false
      if (this.futurePayment) {
        this.futurePayment = false
      }
      event.$emit('goToStandingOrderList', reloadList)
    },

    navigateToAmend () {
      this.config.isSEPAaccount = this.isSEPAaccount
      this.config.fromAccTypeCode = this.fromAccTypeCode
      if (this.config.type === 'same') {
        this.config.fromAccountDescription = this.fromAccountType
        this.config.toAccountDescription = this.toAccountType
        event.$emit('navigateToAmend', this.config)
      } else {
        this.config.debtorAccountDescription = this.fromAccountType
        this.config.debtorAccountNum = this.fromAccountType ? this.fromAccountType.split('-')[1].trim() : ''
        this.config.creditorAccountDescription = this.toAccountType
        event.$emit('amendInterBankPayment', this.config)
      }
    },

    capitalizeFirstLetter (string) {
      const frequency = string.toLowerCase()
      return frequency.charAt(0).toUpperCase() + frequency.slice(1)
    }

  },
  watch: {
    showOTPScreen () {
      if (!this.futurePayment) {
        if ((this.enableOTPForRecurringPayments && this.showOTPScreen) || (this.enableOTPToAddPayee && this.showOTPScreen)) {
          setTimeout(() => {
            event.$emit('SEND_OTP', true)
          }, 200)
        }
      }
      if (this.futurePayment) {
        if ((this.enableOTPForFuturePayments && this.showOTPScreen) || (this.enableOTPToAddPayee && this.showOTPScreen)) {
          setTimeout(() => {
            event.$emit('SEND_OTP', true)
          }, 200)
        }
      }
    }
  },
  beforeDestroy () {
    event.$off('disableFuturePaymentDetails')
    event.$off('reviewDetails')
  }
}
</script>
